import { useState, useEffect, useContext } from 'react'
import { CustomerContext } from '../../contexts/CustomerContext';

const useReformattedSchedules = (schedules, minValue, schoolId = undefined, apptTimeframe) => {
  const [reformatted, setReformatted] = useState({})
  const { customer } = useContext(CustomerContext)
  const currentSchoolId = (customer && customer.currentSchool.id) || schoolId;

  useEffect(() => {
    if (!apptTimeframe) return;
    if (schedules.some((schedule) => !schedule.availableTimeslots)) return

    const shootingDays = [...new Set(schedules.map((schedule) => {
      if (schedule.schoolId === 1075) return `${schedule.shootingDay} @ Shoob`

      return schedule.shootingDay;
    }))]

    const blocksPerAppointment = Math.round(minValue / apptTimeframe) || 1

    const daysToTimes = shootingDays.map((shootingDay) => {
      const times = schedules
        .filter((schedule) => {
          if (shootingDay.includes('@ Shoob')) {
            return schedule.shootingDay === shootingDay.split('@')[0].trim() && schedule.schoolId === 1075
          }

          return schedule.shootingDay === shootingDay && schedule.schoolId === parseInt(currentSchoolId.toString(), 10)
        })
        .map((schedule) => schedule.availableTimeslots)
        .flat()
        .filter((timeslot) => timeslot.numAvailable >= minValue)
        .filter((_schedule, i) => i % blocksPerAppointment === 0 )

      return [shootingDay, times]
    })

    setReformatted(Object.fromEntries(daysToTimes))
  }, [schedules])

  return reformatted
}

export default useReformattedSchedules
